import {
  FETCH_CUSTOMERS,
  GENERATE_REPORT,
  TOAST,
} from "../../../constants/action-types/reporting";

const INITIAL_STATE = {
  customers: [],
  isLoading: false,
  error: null,
  isGenerateReportSuccess: false,
  isGenerateReportError: false,
  toastMessage: null,
  toastSeverity: null,
};

export const reportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GENERATE_REPORT.START:
    case FETCH_CUSTOMERS.START:
      return { ...state, isLoading: true };

    case GENERATE_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isGenerateReportSuccess: true,
        isGenerateReportError: false,
        toastMessage: action.payload.message,
        toastSeverity: action.payload.severity,
      };
    }
    case GENERATE_REPORT.ERROR: {
      return {
        ...state,
        isLoading: false,
        isGenerateReportSuccess: false,
        isGenerateReportError: true,
        error: action.payload,
        toastMessage: action.payload.message,
        toastSeverity: action.payload.severity,
      };
    }

    case FETCH_CUSTOMERS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        customers: action.payload,
      };
    }
    case FETCH_CUSTOMERS.ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    case TOAST.RESET: {
      return {
        ...state,
        isGenerateReportSuccess: false,
        isGenerateReportError: false,
        toastMessage: null,
        toastSeverity: null,
      };
    }
    default:
      return state;
  }
};
